import React, { useEffect } from 'react';
import { NotificationGroup, Notification } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { CpsNotificationType } from '@cs-cms/types';

const DEFAULT_TIMEOUT = 6000;

export interface CpsNotificationProps {
  show: boolean;
  type: CpsNotificationType;
  message: string;
  timeout?: number;
  onClose?: () => void;
}

export const CpsNotification: React.FC<CpsNotificationProps> = props => {
  const { show, type, message, timeout, onClose } = props;

  useEffect(() => {
    if (!show) {
      return undefined;
    }

    const timer = setTimeout(() => {
      onClose?.();
    }, timeout ?? DEFAULT_TIMEOUT);

    return () => clearTimeout(timer);
  }, [show, onClose, timeout]);

  return (
    <NotificationGroup className={'cpsNotification'}>
      <Fade enter={true} exit={true}>
        {show && (
          <Notification type={{ style: type, icon: true }} closable={true} onClose={onClose}>
            <span>{message}</span>
          </Notification>
        )}
      </Fade>
    </NotificationGroup>
  );
};
